const Filters = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8L22 8"
        stroke="#48484D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 16L22 16"
        stroke="#48484D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="8"
        cy="8"
        r="2.25"
        fill="#E8E8E8"
        stroke="#48484D"
        strokeWidth="1.5"
      />
      <circle
        cx="16"
        cy="16"
        r="2.25"
        fill="#E8E8E8"
        stroke="#48484D"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Filters;
